import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import AbEnvironment from '../auth/AbEnvironment';
import PropTypes from 'prop-types';

import withStyles from '@mui/styles/withStyles';
import { Link, Paper, Table, TableHead, TableCell, TableBody, TableRow, Typography } from '@mui/material';
import LoadingSpinner from '../ui/LoadingSpinner';
import AppBindStyles from '../../AppBindStyles';

const abEnvironment = new AbEnvironment();

const styleSheet = theme => ({
  root: {
    flexGrow: 1,
    //marginTop: 10,
    justifyContent: 'flex-end',
    backgroundColor: theme.palette.background.default,
  },
  flex: {
    flex: 1,
  },
  paper: {
    maxWidth: 1200,
    marginTop: '16px'
  }
});

class VendorResellerAnonymousSearch extends Component {
  _isMounted = false;

  state = {
    show: false,
    queryResults: null
  };

  componentDidMount() {
    this._isMounted = true;
    //Had a wierd error messages from react about memory leak on unmounted component
    //It seemed to go away.  If it does come back, here is fix
    //https://github.com/material-components/material-components-web-react/issues/434

    const { callPartnerApi, logError } = this.props.auth;
    let accountId = abEnvironment.getUserAttribute('a_id');


    let aPjwt = abEnvironment.getPjwt();

    let payload = {
      operation: "getVendorAnonymousSubscriptionSummary",
      params: {
        pJwt: aPjwt,
        accountId: accountId,
        appName: null
      }
    };

    callPartnerApi('appbind/generic',
                   'POST',
                   payload
    )
    .then(resp => {
      return resp.json();
    })
    .then(response => {

      if (response != null) {
        let jsonResponse = JSON.parse(response);
        let data = jsonResponse.data.getvendoranonymoussubscriptionsummary;
        if (this._isMounted) {
          this.setState({ show: true, queryResults: data });
        }
        return;
      }

    })
    .catch(error => {
      logError('Exception in VendorResellerAnonymousSearch.js: ' + error); 
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  goTo(route) {
    this.props.history.push(`/${route}`);
  }

  render() {
    const { isAuthenticated, isAuthenticatedVendor, needAssent } = this.props.auth;
    const classes = this.props.classes; 
 
    if (!isAuthenticated() || needAssent()) { 
      return ( <Redirect to='/home' /> );
    } else if (isAuthenticatedVendor()) {

      if (this.state.show) {

        let apps = this.state.queryResults.nodes;

        return ( 
          <div className={classes.paper}>
            <Paper >
              <Table>
                  <TableHead style={AppBindStyles.tableHead}>
                      <TableRow style={AppBindStyles.tableHeadRow}>
                          <TableCell>App</TableCell>
                          <TableCell align="right">Anonymous resellers</TableCell>
                          <TableCell align="right">Subscriptions</TableCell>
                          <TableCell align="right">Total sales</TableCell>
                          <TableCell align="right">Average charge</TableCell>
                          <TableCell align="right">Average markup</TableCell>
                     </TableRow>
                  </TableHead>
                  <TableBody>
                      {apps.map(n => {

                          let aUrl = "app?appId=" + n.appId + "&fp=Resellers";

                          let totalSales = Number(n.totalSales).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2})
                          let averageCharge = Number(n.averageCharge).toLocaleString("en-US", {style: "currency", currency: "USD", minimumFractionDigits: 2})
                          //let averageMarkup = Number(n.averageMarkup).toLocaleString("en-US", {style: "percentage", minimumFractionDigits: 2})
                          let averageMarkup = Number.parseFloat(n.averageMarkup).toFixed(2) + "%";
                          return (
                              <TableRow key={n.appId}>
                                  <TableCell>
                                    <Link component="button" 
                                          variant="body2"
                                          className={classes.custlink}
                                          onClick={this.goTo.bind(this, aUrl)}>
                                      {n.appName}
                                    </Link>
                                  </TableCell>
                                  <TableCell align="right">{n.resellerCount}</TableCell>
                                  <TableCell align="right">{n.subscriptionCount}</TableCell>
                                  <TableCell align="right">{totalSales}</TableCell>
                                  <TableCell align="right">{averageCharge}</TableCell>
                                  <TableCell align="right">{averageMarkup}</TableCell>
                              </TableRow>
                          );
                      })}
                  </TableBody>
              </Table>
            </Paper>
          </div>
        );
      } else {
        return (
          <div>
            <Typography>Loading...</Typography>
            <LoadingSpinner/>
          </div>        
        );
      }
    }
  }
}

VendorResellerAnonymousSearch.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styleSheet)(VendorResellerAnonymousSearch);
